let currentSpaceCb: (event: KeyboardEvent) => void
export const registerSpaceBarEvent = (cb: () => void, isBlockCb = () => false) => {
  if (currentSpaceCb) {
    window.removeEventListener('keydown', currentSpaceCb)
  }
  currentSpaceCb = (event: KeyboardEvent) => {
    if (isBlockCb()) return
    if (event.code === 'Space') {
      event.preventDefault()
      cb()
    }
  }
  window.addEventListener('keydown', currentSpaceCb)
  return () => {
    window.removeEventListener('keydown', currentSpaceCb)
  }
}

export const clearSpaceBarEvent = () => {
  window.removeEventListener('keydown', currentSpaceCb)
}
